export const jobStatus = {
  COMPLETE: "c",
  INCOMPLETE: "i",
};

export default [
  { key: jobStatus.COMPLETE, label: "Complete" },
  { key: jobStatus.INCOMPLETE, label: "Incomeplete" },
];
